import { api } from '@/lib/api/client';
import type { ReportTask, ReportFilters } from '../types';

const ENDPOINT = '/reports/contracts/client';

export const reportsApi = {
  getContractClientReport: async (filters: ReportFilters): Promise<ReportTask[]> => {
    const params: Record<string, unknown> = {};

    // Note: clientId is intentionally not sent to API - it's only used for filtering contracts dropdown
    if (filters.contractId) {
      params.contractId = filters.contractId;
    }
    if (filters.matterId) {
      params.matterId = filters.matterId;
    }
    if (filters.billingPeriodId) {
      params.billingPeriodId = filters.billingPeriodId;
    }
    if (filters['endedAt.min']) {
      const minDate = new Date(filters['endedAt.min']);
      minDate.setHours(0, 0, 0, 0);
      params['endedAt.min'] = minDate.toISOString();
    }
    if (filters['endedAt.max']) {
      const maxDate = new Date(filters['endedAt.max']);
      maxDate.setHours(23, 59, 59, 999);
      params['endedAt.max'] = maxDate.toISOString();
    }

    const response = await api.get<ReportTask[]>(ENDPOINT, { params });
    return response;
  },
};

export const reportsQueryKeys = {
  all: ['reports'] as const,
  contractClient: (filters: ReportFilters) => [...reportsQueryKeys.all, 'contractClient', filters] as const,
};
